<template>
	<form v-on:submit.prevent="submit" :class="[size, formClass, 'vue-form']">
		<button 
			v-if="!readonly && !saveButtonsHidden && !saveButtonFixed && !noTopButton" 
			type="submit" 
			class="btn btn-success top-button" 
			:class="{'fixed':saveButtonFixed}"
			:disabled="saveButtonEnabled">
			<i class="fa" :class="saveButtonIcon"></i>
			&nbsp; 
			<template v-if="saveButtonText">{{ saveButtonText }}</template>
			<template v-else>Save</template>
		</button>

		<slot></slot>

		<div v-if="!readonly && !saveButtonFixed && !saveButtonsHidden && !noBottomButton" class=" mb-2 mt-1">

			<slot name="buttons-left"></slot>
			<div class="float-right">
				<button :disabled="saveButtonEnabled" type="submit" class="btn btn-success"><i class="fa" :class="saveButtonIcon"></i> &nbsp;
					<template v-if="saveButtonText">{{ saveButtonText }}</template>
					<template v-else>Save</template>
				</button>
				<slot name="buttons"></slot>
			</div>
		</div>
		
		<div v-else-if="saveButtonFixed && !saveButtonsHidden && !readonly" class="fixed-bar" :style="{paddingLeft: $store.mainAreaOffset}">
			<div class="fixed-bar-inner" :class="{size,'no-max-width': pushSaveRight}">

				<slot name="buttons-left"></slot>

				<div class="float-right">
					<button :disabled="saveButtonEnabled" type="submit" class="btn btn-success"><i class="fa" :class="saveButtonIcon"></i> &nbsp;
						<template v-if="saveButtonText">{{ saveButtonText }}</template>
						<template v-else>Save</template>
					</button>
					<slot name="buttons"></slot>
				</div>
			</div>
		</div>

		<div style="clear: both;"></div>
	</form>
</template>

<script>

export default {

	name: 'VueForm',
	props: [
		"working",
		"readonly",
		"size", //lg: 1200px, md: 1000px, sm: 800px, xsm: 600px;
		"saveButtonsHidden",
		'saveButtonFixed',
		"saveButtonText",
		"pushSaveRight",
		"noTopButton",
		"noBottomButton"
	],
	data() {
		return {
			saveButtonIcon: "fa-save",
			saveButtonEnabled: null
		}
	},
	watch: {
		working() {
			if (this.working) {
				this.saveButtonIcon = "fa-spin fa-spinner"
				this.saveButtonEnabled = 'disabled'
			}
			else {
				this.saveButtonIcon = "fa-save"
				this.saveButtonEnabled = null
			}
		}
	},
	computed: {
		formClass() {
			if (this.saveButtonFixed)
				return "form-fixed-buttons"
			else
				return ""
		}
	},
	methods: {
		submit() {
			this.$emit("submit")
		}
	},
	created() {

	}

}
</script>

<style type="text/css">

	form.vue-form {
		position: relative;
	}

	form.vue-form, form.vue-form .fixed-bar-inner {
		margin: auto;
	}

	form.vue-form.lg, form.vue-form .fixed-bar-inner.lg {
		max-width: 1200px;
	}

	form.vue-form.md, form.vue-form .fixed-bar-inner.md {
		max-width: 1000px;
	}

	form.vue-form.sm, form.vue-form .fixed-bar-inner.sm {
		max-width: 800px;
	}

	form.vue-form.xsm, form.vue-form .fixed-bar-inner.xsm {
		max-width: 600px;
	}

	form.vue-form .fixed-bar-inner.push-save-right {
		max-width: none!important;
	}

	.vue-form h3 {
		/*margin-bottom: 25px;*/
		margin-bottom: 10px;
	}

	/*form.vue-form h3:first-of-type {
		margin-bottom: 25px;
	}*/

	form.vue-form button.fixed {
		position: fixed;
		bottom: 10px;
		right: 10px;
		z-index: 20;
	}

	form.vue-form .fixed-bar {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		padding: 5px;
		background-color: rgba(10,10,10,0.3);
		z-index: 100;
		transition: 0.5s padding;
	}

	form.vue-form.form-fixed-buttons {
		margin-bottom: 50px;
	}

	.top-button {
		position: absolute;
		right: 0;
		top: -7px;
	}

</style>